module.exports = __webpack_public_path__ + "static/ambient-155307f342558cbc1b455cbebecdf231.mp3";